enum ButtonSize {
  Tiny = 'tiny',
  Normal = 'normal'
}

export default ButtonSize;
